import { ReactNode } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface PageGridProps {
  aside?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function PageGrid (props: PageGridProps) {
  const { children, aside, className } = props

  return (
    <div className={cn(styles.root, className)}>
      {children}

      {aside}
    </div>
  )
}
